import { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';
import clsx from 'clsx';
import { useCopy } from '@/hooks/useCopy';
import { Button } from './ui/Button';

export interface QrCodeViewProps {
  /** 编码内容（分享链接 / PeerID / DID） */
  value: string;
  size?: number;
  /** 是否展示「复制链接」按钮 */
  copyable?: boolean;
  label?: string;
  className?: string;
}

/** 二维码展示（Canvas 渲染 + 复制 + 分享链接）。 */
export function QrCodeView({
  value,
  size = 208,
  copyable = true,
  label,
  className,
}: QrCodeViewProps): JSX.Element {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { copied, copy } = useCopy();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    QRCode.toCanvas(canvas, value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#0B1220', light: '#E6EDF7' },
    })
      .then(() => setError(null))
      .catch(() => setError('二维码生成失败'));
  }, [value, size]);

  return (
    <div className={clsx('flex flex-col items-center gap-3', className)}>
      <div className="rounded-card bg-text/95 p-3">
        <canvas ref={canvasRef} width={size} height={size} aria-label={label ?? '二维码'} />
      </div>
      {error ? <p className="text-xs text-err">{error}</p> : null}
      {label ? <p className="text-xs text-dim">{label}</p> : null}
      {copyable ? (
        <Button variant="ghost" size="sm" onClick={() => void copy(value, '链接已复制')}>
          {copied ? '已复制 ✓' : '复制分享链接'}
        </Button>
      ) : null}
    </div>
  );
}

export default QrCodeView;
